<template>
  <div v-if="isMounted">
    <div class="vx-col w-full mb-3 bg-white">
      <vs-collapse type="border">
        <vs-collapse-item>
          <div slot="header">Search</div>
          <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
            <form>
              <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full" v-if="getProjectSelected.projectType != '3'">
                  <template v-for="fName in showFormFields[0]">
                    <component v-if="handleProjectSelected(fName)" :is="fName[1].type" :structure="fName[1]"
                      :key="fName[0] + status" :index="fName[0]" :value="showValue(fName[0])"
                      @input="data => (inputParams[data.index] = data.value)"></component>
                  </template>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <component v-if="handleProjectSelected(fName)" :is="fName[1].type" :structure="fName[1]"
                    v-for="fName in showFormFields[1]" :key="fName[0] + status" :index="fName[0]"
                    :value="showValue(fName[0])" @input="data => (inputParams[data.index] = data.value)"></component>
                </div>
              </div>

              <vs-row vs-justify="space-around">
                <vs-col
                  v-if="getProjectSelected.projectType == '1' || getProjectSelected.projectType == '3' || getProjectSelected.projectType == '4' || getProjectSelected.projectType == '5' || getProjectSelected.projectType == '6'"
                  vs-type="flex" vs-justify="start" vs-align="start" vs-w="9">
                  <vs-button color="success" @click="filterNow()" class="m-2 text-black font-bold">All</vs-button>
                  <vs-button @click="customFilter('5')" color="gray" class="m-2 text-black font-bold">No
                    Status</vs-button>
                  <vs-button @click="customFilter('1')" color="primary" class="m-2 text-black font-bold">Break</vs-button>
                  <vs-button @click="customFilter('2')" color="danger" class="m-2 text-black font-bold">Defect</vs-button>
                  <vs-button @click="customFilter('3')" color="yellow" class="m-2 text-black font-bold">Box-up</vs-button>
                  <vs-button @click="customFilter('4')" color="success"
                    class="m-2 text-black font-bold">Complete</vs-button>
                </vs-col>
                <vs-col v-if="getProjectSelected.projectType == '2'" vs-type="flex" vs-justify="start" vs-align="start"
                  vs-w="9">
                </vs-col>
                <vs-col vs-type="flex" vs-justify="end" vs-align="end" vs-w="3">
                  <vs-button @click="filterNow()" class="m-2 text-black font-bold">Search</vs-button>

                  <vs-button type="border" color="warning" @click="reset()"
                    class="m-2 text-black font-bold">Reset</vs-button>
                </vs-col>
              </vs-row>
              <vs-row>
                <vs-col vs-type="flex" vs-justify="end" vs-align="end" vs-w="12">
                  <span style="padding: 10px; font-size: 16px">Total </span>
                  <span style="
                      padding: 10px;
                      font-size: 16px;
                      background-color: green;
                      color: white;
                      font-weight: bold;
                    ">{{ totalData }}</span>
                </vs-col>
              </vs-row>
            </form>
          </component>
        </vs-collapse-item>
      </vs-collapse>
    </div>
  </div>
</template>

<script>
import axios from '@/axios.js'
import { mapGetters } from 'vuex'

import aronTextbox from '../formElements/textbox'
import aronInteger from '../formElements/integer'
import aronPassword from '../formElements/password'
import aronSelect from '../formElements/select'
import aronMultiSelect from '../formElements/multiselect'
import aronRadio from '../formElements/radio'
import aronRadioStatic from '../formElements/radioStatic'
import aronTextarea from '../formElements/textArea'
import aronCurrency from '../formElements/currency'
import aronNumber from '../formElements/number'
import aronDate from '../formElements/date'
import aronYearOnly from '../formElements/yearOnly'
import aronFile from '../formElements/file'

import VuePerfectScrollbar from 'vue-perfect-scrollbar'
export default {
  components: {
    aronTextbox,
    aronPassword,
    aronSelect,
    aronMultiSelect,
    aronRadio,
    aronRadioStatic,
    aronTextarea,
    aronCurrency,
    aronNumber,
    aronDate,
    aronYearOnly,
    aronFile,
    aronInteger,
    VuePerfectScrollbar
  },

  props: {
    totalData: Number
  },

  data() {
    return {
      status: 'normal',
      baseUrl: axios.defaults.baseURL,
      isMounted: false,
      currentView: 'list',
      inputParams: {},
      errorParams: [],
      data: {},
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      }
    }
  },

  computed: {
    ...mapGetters({
      getUserInfo: 'auth/getUserInfo',
      getOrigCurrentDataStructure: 'profile/getOrigCurrentDataStructure',
      getOrigDataStructure: 'profile/getOrigDataStructure',
      scrollbarTag: 'main/scrollbarTag',
      getProjectSelected: 'auth/getProjectSelected'
    }),

    showFormFields() {
      try {
        console.log(
          'childDataMarker:',
          this.$store.state.profile.childDataMarker
        )

        var dataFilter = {}

        if (this.getProjectSelected.projectType == '2') {
          dataFilter = _.pickBy(this.getOrigDataStructure, function (st) {
            console.log('ststst:', st.colName)
            if (st.hasOwnProperty('showAsFilter')) {
              return (
                st.colName == 'equipmentTagFilter' ||
                st.colName == 'jointFilter' ||
                st.colName == 'jointType'
              )
            }
          })
        } else if (this.getProjectSelected.projectType == '4') {
          dataFilter = _.pickBy(this.getOrigDataStructure, function (st) {
            if (st.hasOwnProperty('showAsFilter')) {
              return (
                st.colName == 'workIdFilter' ||
                st.colName == 'equipmentTagFilter' ||
                st.colName == 'contractorFilter' ||
                st.colName == 'areaFilter' ||
                st.colName == 'criticalFilter' ||
                st.colName == 'workListFilter'
              )
            }
          })
        }
        else {
          dataFilter = _.pickBy(this.getOrigDataStructure, function (st) {
            if (st.hasOwnProperty('showAsFilter')) {
              return st.showAsFilter.toLowerCase() == 'yes'
            }
          })
        }

        if (this.$store.state.profile.childDataMarker == 'child') {
          console.log('current struc:', this.getOrigCurrentDataStructure)

          dataFilter = _.pickBy(this.getOrigCurrentDataStructure, function (
            st
          ) {
            if (st.hasOwnProperty('showAsFilter')) {
              return st.showAsFilter.toLowerCase() == 'yes'
            }
          })
        }

        console.log('dataFilter:', dataFilter)

        var objCount = Math.ceil(Object.entries(dataFilter).length / 2)
        console.log('objCount:', objCount)
        const arrayFromObject = Object.entries(dataFilter)
        return _.chunk(arrayFromObject, objCount)
      } catch (exception) {
        console.error(exception)
      }
    }
  },

  // 1. fil
  created() { },

  mounted() {
    if (this.showFormFields.length > 0) {
      this.isMounted = true
    } else {
      this.isMounted = false
    }
    console.log('showFormFields:', this.showFormFields)
  },

  methods: {
    handleProjectSelected(fName) {
      console.log('fName:', fName[0]);
      if (this.getProjectSelected.projectType == "1") {
        if (
          fName[0] == "workListFilter" ||
          fName[0] == "equipmentTagFilter" ||
          fName[0] == "Contractor" ||
          fName[0] == "contractorFilter" ||
          fName[0] == "areaFilter"
        ) {
          return false;
        }
        return true;
      } else if (this.getProjectSelected.projectType == "2") {
        if (
          fName[0] == "workListFilter" ||
          fName[0] == "equipmentTagFilter" ||
          fName[0] == "Contractor" ||
          fName[0] == "contractorFilter" ||
          fName[0] == "areaFilter"
        ) {
          return false;
        }
        return true;
      }

      else {
        return true;
      }
    },
    customFilter(status) {
      this.inputParams['status'] = status
      this.$emit('submit', this.inputParams)

      this.status = 'submit'
    },
    filterNow() {
      this.inputParams['status'] = ''
      this.$emit('submit', this.inputParams)
      this.status = 'submit'
    },
    reset() {
      this.$emit('submit', {})
      this.inputParams = {}
      this.status = 'reset'
    },
    showValue(colName) {
      return this.inputParams[colName]
    },
    collapse(event) {
      console.log('eventsss:', event)
    }
  }
}
</script>

